import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-create-bank',
  templateUrl: './create-bank.component.html',
  styleUrls: ['./create-bank.component.scss'],
})
export class CreateBankComponent implements OnInit {
  @Input() edit: any;
  bankForm: FormGroup;
  currencies: any[];
  createdBanks: any[] = [];
  editing = false;
  idBankSelected: number;
  storeId: number;
  constructor(
    private fb: FormBuilder,
    private modalController: ModalController,
    private httpSv: HttpService,
    private uiSv: UiServices,
    private translateSv: TranslateService
  ) { }

  async ngOnInit() {
    
    
    this.bankForm = this.fb.group({
      nameBank: ['', [Validators.required]],
      name: ['', [Validators.required]],
      typeDoc: ['', [Validators.required]],
      dni: ['', [Validators.required]],
      number: ['', [Validators.required]],
      numberAccount: ['', [Validators.required]],
      accountType: ['', [Validators.required]],
      currencyId: ['', [Validators.required]],
      email: [''],
    })
    const res: any = await this.httpSv.itemIndex('currency');
    this.currencies = res.data;
    if(this.edit){
      this.bankForm.patchValue(this.edit);
      this.editing = true;
    }

      // this.createdBanks = this.edit.createdBanks;
  }

  setBankId(ev){
    const idBank = ev.detail.value;    
    if(idBank === 'create'){
      this.bankForm.reset();
      this.idBankSelected = undefined;
      this.editing = false;
    }else{
      this.idBankSelected = idBank;
      const findBank = this.createdBanks.find(bank => bank.id === idBank);
      this.storeId = findBank.store_id;
      this.bankForm.patchValue(findBank);
      this.editing = true;
    }
  }

  async storeMethod(){
    try{
      await this.uiSv.showLoading();
      const type = (this.edit) ? 'update' : 'store';
      const txtType = (this.edit) ? 'editado' : 'creado';
      if(this.edit){
        this.bankForm.value.id = this.edit.id;
      }
      await this.httpSv.itemAction(this.bankForm.value, 'methodsType', type);
      await this.uiSv.loading.dismiss();
      await this.modalController.dismiss();
      const translateMet = this.translateSv.instant('METODO_DE_PAGO');
      const translateExt = this.translateSv.instant('EXITOSAMENTE');
      await this.uiSv.showToast(`${translateMet} ${txtType} ${translateExt}`);
    }catch(err){
      await this.uiSv.loading.dismiss(); 
      console.error(err);
      
    }
  }

  closeModal(closed){
    if(this.idBankSelected !== undefined){
      this.bankForm.value.id = this.idBankSelected;
      
    }

    // this.bankForm.value.number = `${ this.socialInput?.prefPhone || this.socialInput?.code }${this.bankForm.value.number}`
    this.modalController.dismiss(closed ? null : this.bankForm.value, ( this.editing ) ? 'edit' : 'create');
  }

  async deleteBank(){
    // const res = await this.uiSv.presentAlert('Seguro de eliminar este banco?', 'Esta acción es irreversible');
    // if(res.role === 'accept'){
    //   const data = {
    //     id: this.idBankSelected,
    //     storeId: this.storeId
    //   }
    //   this.directorioSv.deleteBank(data).subscribe(res => {
    //     this.modalController.dismiss();
    //   })
    // }
  }
}
